module.exports = __webpack_public_path__ + "static/media/closeup-type.2595ab05.jpg";